import { Box, Avatar, Typography } from "@mui/material";

import ScanIcon from "../../../../Assets/Icons/scan-icon.png";

import StatusCell from "./StatusCell";
import ActionsCell from "./ActionsCell";

export const getColumns = (
  handleEdit,
  setOpenDeleteUser,
  setOpen,
  setSelectedUser,
  setOpenStatusChangeModal,
  hasClearOrders,
  hasOnBreakStatus,
  setOpenBreakReport,
  setSelectedUserForBreakReport,
) => [
  {
    field: "full_name",
    headerName: "Full Name",
    width: 250,
    renderCell: (params) => (
      
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Avatar
          src={params.row.profile_photo}
          alt={params.row.full_name}
          sx={{ marginRight: 1, height: "36px", width: "36px" }}
        />
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
          }}
        >
          {params.row.full_name}
        </Typography>
      </Box>
    ),
  },
  {
    field: "role",
    headerName: "Role",
    width: hasClearOrders ? 120 : 150,
    renderCell: (params) => (
      <Box display="flex" alignItems="center">
        {params.value === "Picker" ? (
          <>
            {params.value}
            <img src={ScanIcon} alt="Scan Icon" style={{ marginLeft: 16 }} />
          </>
        ) : (
          <span>{params.value}</span>
        )}
      </Box>
    ),
  },
  {
    field: "user_name",
    headerName: "Username",
    width: 150,
    renderCell: (params) => params.value || "-",
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <StatusCell
        params={params}
        setSelectedRow={setSelectedUser}
        setOpenStatusChangeModal={setOpenStatusChangeModal}
      />
    ),
  },
  {
    field: "action",
    headerName: "Action",
    width: 700,
    sortable: false,
    renderCell: (params) => (
      <ActionsCell
        params={params}
        handleEdit={handleEdit}
        setOpenDeleteUser={setOpenDeleteUser}
        setOpen={setOpen}
        setSelectedUser={setSelectedUser}
        setOpenStatusChangeModal={setOpenStatusChangeModal}
        setOpenBreakReport={setOpenBreakReport}
        setSelectedUserForBreakReport={setSelectedUserForBreakReport}
      />
    ),
  },
];
